import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=36acbe32&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36acbe32')) {
      api.createRecord('36acbe32', component.options)
    } else {
      api.reload('36acbe32', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=36acbe32&", function () {
      api.rerender('36acbe32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserList.vue"
export default component.exports